import 'primary/events/components/matchs/edit/TeamScoreEditRow.scss';

import { Edit } from '@mui/icons-material';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { UnpyMatch } from 'domain/event/match/UnpyMatch';
import { SystemPointsEnum } from 'domain/event/SystemPoints.enum';
import { TypeEventCodeEnum } from 'domain/event/TypeEventCodeEnum';
import {
  setMatchUpdateModalClose,
  setMatchUpdateModalOpen,
} from 'domain/modal/store/ModalSlice';
import { formatDate } from 'helper/date.helper';
import { NeonText } from 'primary/Components/NeonText/NeonText';
import { IconPodiumByIndex } from 'primary/events/components/PodiumView';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';
import { useDispatch } from 'react-redux';

type TeamScoreEditRowProps = {
  match: UnpyMatch;
  className?: string;
  systemPoint: SystemPointsEnum;
  onEdited: () => void;
  typeEvent: TypeEventCodeEnum;
  isClassementReadOnly?: boolean;
  asView?: boolean;
};

export const TeamScoreEditRow = ({
  systemPoint,
  className,
  match,
  onEdited,
  typeEvent,
  asView,
  isClassementReadOnly,
}: TeamScoreEditRowProps) => {
  const t = useTranslate();
  const dispatch = useDispatch();
  const closeEditScore = () => dispatch(setMatchUpdateModalClose());
  const handleValidateEditScore = () => {
    onEdited();
    closeEditScore();
  };
  const openModalTeam = () => {
    dispatch(
      setMatchUpdateModalOpen({
        //@ts-ignore
        props: {
          systemPoint: systemPoint,
          handleClose: closeEditScore,
          onValidEdit: handleValidateEditScore,
          match: match,
        },
      }),
    );
  };

  const participant1 = match.participants[0];
  const participant2 = match.participants[1];
  const isParticipant1Win =
    participant1?.score != null &&
    participant2?.score != null &&
    participant1?.score > participant2?.score;
  const isParticipant2Win =
    participant2?.score != null &&
    participant1?.score != null &&
    participant2?.score > participant1?.score;
  return (
    <div className={classNames('teamScoreEditRow', className)}>
      <div className={classNames('teamScoreEditRow__teams', '-casePart')}>
        <div className={'-teamsContainer'}>
          <div className={'-teamsContainer__scoreWithIcon -left'}>
            {participant1?.score !== null && (
              <span className={'-teamScore'}>
                {typeEvent === 'LIGUE'
                  ? participant1?.score
                  : participant1?.score !== undefined
                  ? t(
                      `classement.abreviationResult.${
                        isParticipant1Win ? 'WIN' : 'LOOSE'
                      }`,
                    )
                  : 'N/A'}
              </span>
            )}
            {isParticipant1Win ? IconPodiumByIndex[0] : null}
          </div>
          <div className={'-nameContainer -left'}>
            <span
              className={classNames('-teamName', {
                '-withoutIcon': !isParticipant1Win,
              })}
            >
              {participant1?.eventParticipant.team?.name ??
                t('event.matchs.edit.editScore.noTeam')}
            </span>
          </div>
          <div className={'-vsContainer'}>
            <NeonText variant={'orange'} text={'VS'} />
            <span className={'-matchStartDateVs'}>
              {match.startDate
                ? formatDate(match.startDate, 'readable(with hour)')
                : '--:--:----'}
            </span>
          </div>
          <div className={'-nameContainer -right'}>
            <span
              className={classNames('-teamName', {
                '-withoutIcon': !isParticipant2Win,
              })}
            >
              {participant2?.eventParticipant.team?.name ??
                t('event.matchs.edit.editScore.noTeam')}
            </span>
          </div>
          <div className={'-teamsContainer__scoreWithIcon -right'}>
            {isParticipant2Win ? IconPodiumByIndex[0] : null}
            {participant2?.score !== null ? (
              <span className={'-teamScore'}>
                {typeEvent === 'LIGUE'
                  ? participant2?.score
                  : participant2?.score !== undefined
                  ? t(
                      `classement.abreviationResult.${
                        isParticipant2Win ? 'WIN' : 'LOOSE'
                      }`,
                    )
                  : 'N/A'}
              </span>
            ) : null}
          </div>
        </div>
        {!asView && (
          <div className={'-actionContainer'}>
            <Button
              color={'primary'}
              style={{ justifySelf: 'flex-end' }}
              variant={'text'}
              onClick={openModalTeam}
              disabled={isClassementReadOnly}
            >
              <Edit />
              {t('event.eventViewPage.scoreboard.editScore')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
